import { useId } from "react"
import { Tooltip } from "react-tooltip"
import "react-tooltip/dist/react-tooltip.css"

import ESTIMATE_CONSTANT from "../../../../constant/estimateConstant"
import type { OneClickFieldProps } from "../../../../types"
import FieldSet from "../../../components/1Click/FieldSet"

import OneClickFieldMessages from "../../../components/1Click/form/OneClickFieldMessages"
import LINKS from "../../../constant/links"

import rigidImage from "./01_rigid.png"
import flexibleImage from "./02_flexible.png"
import metalImage from "./03_metal.png"
import harnessImage from "./04_harness.png"
import { TabGroup, TabItem } from "../../../../../../shadcn/TabGroup"

const ItemSelect = ({ values, handlers, errors }: OneClickFieldProps) => {
  const harnessTooltipId = useId()
  const labelId = useId()

  const handleKibanTypeChange = (value: string) => {
    handlers.kibanType({ target: { value } } as React.ChangeEvent<HTMLInputElement>)
  }

  return (
    <section className="mb-16">
      <h3 id={labelId} className="mb-4 font-bold text-[#32383e]">
        製造するアイテムを選択
      </h3>
      <FieldSet aria-labelledby={labelId}>
        <TabGroup
          value={values.kibanType || ESTIMATE_CONSTANT.基板の種類.リジッド基板.value}
          onValueChange={handleKibanTypeChange}
          defaultValue={ESTIMATE_CONSTANT.基板の種類.リジッド基板.value}
        >
          <TabItem value={ESTIMATE_CONSTANT.基板の種類.リジッド基板.value} thumbnail={rigidImage}>
            リジッド基板
          </TabItem>
          <TabItem value={ESTIMATE_CONSTANT.基板の種類.フレキシブル基板.value} thumbnail={flexibleImage}>
            フレキシブル基板
          </TabItem>
          <TabItem value={ESTIMATE_CONSTANT.基板の種類.メタル放熱基板.value} thumbnail={metalImage}>
            メタル放熱基板
          </TabItem>
          <a
            href={LINKS.HARNESS}
            className="flex flex-1 items-center justify-between gap-2 px-2 pb-3 pt-2 text-[15px] font-bold text-neutral-400"
          >
            <span>ハーネス加工</span>
            <div className="relative size-16">
              <img
                src={harnessImage}
                alt="ハーネス加工の画像"
                className="pointer-events-none inset-0 size-full max-w-none object-contain object-center"
              />
            </div>
          </a>
        </TabGroup>
        <Tooltip anchorId={harnessTooltipId} place="bottom" content="ハーネス加工サービスは別ウィンドウで開きます。" />
        <OneClickFieldMessages error={errors?.kibanType} />
      </FieldSet>
    </section>
  )
}

export default ItemSelect
